module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-shadow-16.b9953cd6.png";